// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-28fa20c6],.cls-2[data-v-28fa20c6]{fill:var(--v-primary-base)}", ""]);
// Exports
module.exports = exports;
